import React from 'react'

const AllProceduresContext = React.createContext()

export default AllProceduresContext